import { Fragment } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';

export const Info = ({
  title,
  description,
  infoClassName,
  currentCategoriesId
}) => {
  const { imageElements, categories: allCategories } = useSettings();

  const currentCategories = allCategories.reduce((acc, category) => {
    if (currentCategoriesId.includes(category.id)) {
      acc.push(category);
    }

    return acc;
  }, []);

  const hasContent = !!title || !!description || !!currentCategories.length;
  const shouldRender = !!imageElements.length && hasContent;

  if (!shouldRender) {
    return null;
  }

  return (
    <Container className={infoClassName}>
      {imageElements.includes('title') && !!title && <Title>{title}</Title>}

      {imageElements.includes('description') && !!description && (
        <Description>{description}</Description>
      )}

      {imageElements.includes('categories') && !!currentCategories.length && (
        <Categories>
          {currentCategories.map((category, index) => (
            <Fragment key={category.id}>
              {index > 0 && <Separator> · </Separator>}
              <Category>{category.name}</Category>
            </Fragment>
          ))}
        </Categories>
      )}
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${meta.stylePrefix}-info-component`
})`
  position: relative;
  z-index: 1;
`;

const Title = styled.div.attrs({
  className: `${meta.stylePrefix}-info-title`
})`
  font-size: 20px;
  font-weight: bold;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const Description = styled.div.attrs({
  className: `${meta.stylePrefix}-info-description`
})`
  font-size: 15px;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

const Categories = styled.div.attrs({
  className: `${meta.stylePrefix}-info-categories`
})`
  font-size: 13px;
  line-height: 16px;
`;

const Category = styled.span.attrs({
  className: `${meta.stylePrefix}-info-category`
})`
  opacity: 0.7;
`;

const Separator = styled.span.attrs({
  className: `${meta.stylePrefix}-info-separator`
})``;
